import React, { PureComponent } from "react";
import PropTypes from "prop-types";

export default class SizeSelect extends PureComponent {
  onChange = (evt) => {
    const { onChange } = this.props;
    if (onChange === null) {
      return;
    }

    const value = evt.target.value.length > 0 ? evt.target.value : null;
    onChange({ [evt.target.name]: value });
  };

  render() {
    const { value, name, className } = this.props;
    return (
      <div className={`select ${className || ""}`}>
        {/* In case `value` happened to get passed through as null, swap it for an empty string to prevent console errors */}
        <select name={name} onChange={this.onChange} value={value || ""}>
          <option value="">Any Size</option>
          <option value="1-10">1-10 employees</option>
          <option value="11-25">11-25 employees</option>
          <option value="26-50">26-50 employees</option>
          <option value="51-100">51-100 employees</option>
          <option value="101+">&gt; 100 employees</option>
        </select>
      </div>
    );
  }
}

SizeSelect.defaultProps = {
  value: "",
  className: "",
};

SizeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};
